import {WINDOW_DELIMITER_WIDTH} from '../constants';

const
  NAME               = 'arrowsDisplay',
  VERSION            = '1.1.0',
  JQUERY_NO_CONFLICT = $.fn[NAME],
  THROTTLE_INTERVAL  = 400, // NOTE: Interval in miliseconds to execute the scroll event callback
  _window$           = $(window)
;

var _lastScrollTop = 0;

/**
 * Plugin to show Next and Back arrows on the left and right sides of page, when the
 * user are scrolling up on page
 */
class ArrowsDisplay {
  constructor(element$, options) {
    this._target$        = element$.find('a');
    this._options        = options;
    this._overlapElement = $(this._options.hideOverlapClass).first();

    _window$.on('scroll', _.throttle((e) => this.onScroll(e), THROTTLE_INTERVAL));
  }

  onScroll(/*event*/) {
    var scrollTop;

    scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (!_isMobileWidth() || (_isMobileWidth() && _areArrowsOverlappingElement(scrollTop, this._overlapElement))) {
      if (scrollTop > _lastScrollTop) {
        // NOTE: Downscroll code
        this._target$.removeClass('voc-active');
      } else {
        // NOTE: Upscroll code
        this._target$.addClass('voc-active');
      }

      _lastScrollTop = scrollTop;
    } else {
      // NOTE: Hide arrows when they are overlapping the element with hideOverlapClass
      this._target$.removeClass('voc-active');
    }
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(options) {
    return this.each(function() {
      new ArrowsDisplay($(this), options);
    });
  }
}

$.fn[NAME]             = ArrowsDisplay._jQueryInterface;
$.fn[NAME].Constructor = ArrowsDisplay;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return ArrowsDisplay._jQueryInterface;
};

export default ArrowsDisplay;

/* Private methods */

/**
 *  Check if the width of window is a mobile width
 */
function _isMobileWidth() {
  return window.innerWidth <= WINDOW_DELIMITER_WIDTH;
}

/**
 *  Check if the arrows are overlapping the elements passed in options
 */
function _areArrowsOverlappingElement(scrollTop, element$) {
  return element$.length && scrollTop < (element$.offset().top - (window.innerHeight / 2));
}



// WEBPACK FOOTER //
// ./src/plugins/arrows-display.js